<template>
  <div class="inline-message" :style="containerStyle">
    <div class="inline-message__content">
      <div v-if="showIcon" class="inline-message__icon">
        <img :src="require('@/assets/warning-yellow.svg')" alt="" />
      </div>
      <div class="inline-message__text">
        <div class="inline-message__body">{{ content }}</div>
        <div v-if="showAction" class="inline-message__action">
          <a href="#" class="inline-message__link">{{ actionText }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InlineMessageAlert',
  props: {
    type: {
      type: String,
      default: 'warning',
      validator: value =>
        ['warning', 'error', 'info', 'success'].includes(value),
    },
    content: {
      type: String,
      default:
        "Provide accurate details or this transaction will fail. To comply with Travel Rule regulations, we're required to gather these details.",
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    showAction: {
      type: Boolean,
      default: false,
    },
    actionText: {
      type: String,
      default: 'Learn more',
    },
    customStyles: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    containerStyle() {
      return {
        ...this.customStyles,
      };
    },
  },
};
</script>

<style scoped>
.inline-message {
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px 16px;
  width: 94%;
  background: #fff5d6;
  border-radius: 16px;
  box-sizing: border-box;
}

.inline-message__content {
  display: flex;
  width: 100%;
  gap: 12px;
  align-items: center;
}

.inline-message__icon {
  flex-shrink: 0;
}

.inline-message__text {
  flex: 1;
  color: #333333;
  font-size: 14px;
  line-height: 1.4;
}

.inline-message__body {
  font-weight: 400;
  font-size: 12px;
  size: 12px;
  letter-spacing: 0px;
  line-height: 18px;
}

.inline-message__action {
  margin-top: 4px;
}

.inline-message__link {
  color: #4fa58c;
  text-decoration: none;

  font-family: Jost;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0px;
}

.inline-message__link:hover {
  text-decoration: underline;
}
</style>
